"use client";

/**
 * AnalyticsProvider — Amplitude 를 한 번 켠다.
 * @description `trackEvent` 는 SDK 가 켜지기 전까지 이벤트를 큐에 쌓아 두기만 한다. 켜는 일을
 *   화면마다 맡겨 두면(콜랩 상세 · 가입) 그 밖의 화면에서 쌓인 이벤트가 영영 나가지 않는다 —
 *   홈과 글 상세가 그랬다. 루트 레이아웃에서 한 번 켜서 어느 화면이든 같은 조건에 둔다.
 *   페이지뷰는 SDK 의 autocapture 가 라우트마다 스스로 남긴다.
 */
import { useEffect } from "react";

import { initAmplitude } from "./amplitude";

export function AnalyticsProvider() {
  useEffect(() => {
    initAmplitude();
  }, []);
  return null;
}
